import { useNavigate } from 'react-router-dom'
import toast from 'react-hot-toast'
import { StepProps } from '../TimsurveyWizard'
import { timsurveyApi } from '../../../services/api'

export default function StepFine({ pratica }: StepProps) {
  const navigate = useNavigate()

  const anteprimaPdf = async () => {
    try {
      const res = await timsurveyApi.pratiche.pdf(pratica.id)
      const url = URL.createObjectURL(res.data as Blob)
      window.open(url, '_blank')
    } catch {
      toast.error('Errore generazione PDF')
    }
  }

  return (
    <div className="card p-8 text-center space-y-4">
      <div className="text-3xl">✅</div>
      <div className="text-lg font-semibold text-slate-800">Verbale completato</div>
      <p className="text-sm text-slate-500">Il verbale è stato compilato e firmato. Il backoffice procederà con la chiusura definitiva della pratica.</p>
      <div className="flex flex-col gap-2">
        <button className="btn-secondary" onClick={anteprimaPdf}>Visualizza anteprima PDF</button>
        <button className="btn-primary" onClick={() => navigate('/timsurvey')}>Torna alla lista</button>
      </div>
    </div>
  )
}
